import classNames from 'classnames';
import { HtmlHTMLAttributes } from 'react';
import { Button, Checkbox } from 'rsuite';
import { ItemDataType } from 'rsuite/lib/@types/common';
import { InnerFilter, IUseFilter } from '../../../../../components';
import styles from './NewFilters.module.scss';
export type FilterSectionProps = IUseFilter & Omit<HtmlHTMLAttributes<HTMLDivElement>, 'onSelect'>;

export const NewFilters = ({
  className,
  data = {},
  values = {},
  savedFilter,
  filters = [],
  isEmpty = true,
  modals,
  loading,
  onSearch,
  onSelect,
  onClearAll,
  onSelectAll,
  onOpenModal,
  onCloseModal,
  onSaveFilter,
  onDeleteFilter,
  onSelectSavedFilter,
  ...props
}: FilterSectionProps) => {
  return (
    <div className={classNames(styles['filter-section'], className)} {...props}>
      <div className={classNames(styles.row, styles.row1)}>
        <div>
          {filters.map(
            ({ key, placeholder, type, ...rest }) =>
              !key.match(/category/) &&
              !key.match(/savedFilters/) && (
                <InnerFilter
                  key={key}
                  data={data[key] ?? []}
                  value={values[key] ?? []}
                  placeholder={placeholder as string}
                  type={type}
                  isLoading={loading?.[key]}
                  textSearch={rest.textSearch}
                  textLoading={rest.textLoading}
                  onSelect={value => onSelect(key, value)}
                  onSearch={query => onSearch(key, query)}
                  onClose={() => onSearch(key, '')}
                  onClean={() => {
                    onSearch(key, '');
                    onSelect(key, []);
                  }}
                  renderMenuItem={(value, item: ItemDataType & { order?: number }) => {
                    if (item.order !== undefined) {
                      return (
                        <div className={styles['order-item']}>
                          <span className={styles['hash-order']}>#{item.order}</span>
                          <span>{item.label}</span>
                        </div>
                      );
                    }

                    return value;
                  }}
                  renderExtraFooter={
                    rest.selectAll
                      ? () => {
                          const isChecked = data[key]?.length === values[key]?.length;
                          return (
                            <div className="picker-pill-footer">
                              <Checkbox
                                inline
                                indeterminate={!isChecked && !!values[key]?.length}
                                checked={isChecked}
                                onChange={(_v, checked) => onSelectAll?.(key, checked)}
                              >
                                Selecionar todos
                              </Checkbox>
                            </div>
                          );
                        }
                      : undefined
                  }
                  searchable={(rest.searchable as boolean) ?? true}
                />
              ),
          )}
        </div>
        {onClearAll && (
          <Button className={styles['filter-section__button']} onClick={onClearAll}>
            Limpar filtros
          </Button>
        )}
      </div>
    </div>
  );
};
